<script lang="ts">
	import { classes } from '$lib/utils';

	export let id: string = '';
	// The title of the content section like e.g. CURICCULUM.
	export let sectionTitle: string;
	export let title: string;
	export let description: string | null = null;
	export let additionalClass: string = '';
	// This will override the default row behaviour.
	export let additionalContentClass: string = 'flex flex-row';
</script>

<div {id} class={classes(additionalClass, 'flex flex-col')}>
	<div class="flex flex-col gap-3 break-words">
		<div class="text-lg uppercase">{sectionTitle}</div>
		<h3 class="text-4xl uppercase font-bold max-w-[768px]">{title}</h3>
		{#if description}
			<div class="text-lg max-w-[768px]">{@html description}</div>
		{/if}
	</div>
	<div
		class={classes(
			additionalContentClass,
			'gap-6 mt-12 w-full col-start-1 col-end-13 justify-center md:justify-start md:items-start'
		)}
	>
		<slot />
	</div>
</div>
